import { ReadonlyNonEmptyArrayType, readonlyNonEmptyArrayC } from "../../codecs/readonlyNonEmptyArray";
import * as t from "io-ts";
import { LocalDateOrd } from "../../syntax/date/jodaSyntax";
import * as E from "fp-ts/lib/Either";
import { TaggedContent as imported124_TaggedContent, TaggedContentC as imported119_TaggedContentC, taggedContentC as imported121_taggedContentC, TaggedContent as imported118_TaggedContent, TaggedContentC as imported121_TaggedContentC, TaggedContent as imported123_TaggedContent, TaggedContent as imported122_TaggedContent, taggedContentC as imported120_taggedContentC, taggedContentC as imported122_taggedContentC, TaggedContentC as imported123_TaggedContentC, TaggedContentC as imported124_TaggedContentC, taggedContentC as imported119_taggedContentC, TaggedContentC as imported122_TaggedContentC, TaggedContent as imported119_TaggedContent, taggedContentC as imported118_taggedContentC, taggedContentC as imported123_taggedContentC, TaggedContentC as imported120_TaggedContentC, TaggedContent as imported120_TaggedContent, TaggedContent as imported121_TaggedContent, taggedContentC as imported124_taggedContentC, TaggedContentC as imported118_TaggedContentC } from "./taggedContent";
import * as O from "fp-ts/lib/Option";
import { pipe } from "fp-ts/lib/function";
import * as Ord from "fp-ts/lib/Ord";
import { EventC as imported12_EventC, Event as imported12_Event, eventC as imported11_eventC } from "./event";
import { ReadonlyMapFromEntriesC, readonlyMapFromEntries } from "io-ts-types/lib/readonlyMapFromEntries";
import { WithModInfo as imported136_WithModInfo, WithModInfoC as imported137_WithModInfoC, WithStatusCU as imported450_WithStatusCU, withModInfoC as imported135_withModInfoC, WithModInfoC as imported136_WithModInfoC, WithModInfo as imported133_WithModInfo, WithStatusU as imported224_WithStatusU, withModInfoC as imported136_withModInfoC, withModInfoC as imported132_withModInfoC, withModInfoC as imported133_withModInfoC, WithId as imported154_WithId, WithStatusCU as imported447_WithStatusCU, WithId as imported155_WithId, withIdC as imported154_withIdC, WithModInfoC as imported132_WithModInfoC, WithModInfoC as imported134_WithModInfoC, WithStatusU as imported226_WithStatusU, WithId as imported157_WithId, WithStatusU as imported223_WithStatusU, WithModInfo as imported132_WithModInfo, WithId as imported158_WithId, withIdC as imported153_withIdC, WithStatusCU as imported453_WithStatusCU, withModInfoC as imported130_withModInfoC, withModInfoC as imported134_withModInfoC, WithModInfo as imported130_WithModInfo, withModInfoC as imported131_withModInfoC, WithStatusCU as imported446_WithStatusCU, WithIdC as imported154_WithIdC, WithModInfo as imported135_WithModInfo, WithIdC as imported156_WithIdC, withIdC as imported156_withIdC, withIdC as imported158_withIdC, withIdC as imported157_withIdC, WithStatusCU as imported448_WithStatusCU, WithIdC as imported157_WithIdC, WithStatusCU as imported449_WithStatusCU, WithIdC as imported159_WithIdC, WithIdC as imported155_WithIdC, WithStatusCU as imported451_WithStatusCU, WithStatusU as imported225_WithStatusU, WithIdC as imported153_WithIdC, WithModInfo as imported134_WithModInfo, WithModInfoC as imported135_WithModInfoC, WithModInfo as imported137_WithModInfo, WithModInfoC as imported131_WithModInfoC, WithModInfoC as imported133_WithModInfoC, WithModInfo as imported131_WithModInfo, WithIdC as imported158_WithIdC, WithId as imported156_WithId, withModInfoC as imported137_withModInfoC, WithStatusCU as imported452_WithStatusCU, WithId as imported159_WithId, withIdC as imported159_withIdC, withIdC as imported155_withIdC, WithId as imported153_WithId, WithModInfoC as imported130_WithModInfoC } from "./threadThrough";
import { issuerC as imported36_issuerC, IssuerC as imported41_IssuerC, issuerC as imported41_issuerC, Issuer as imported37_Issuer, issuerC as imported39_issuerC, IssuerC as imported40_IssuerC, issuerC as imported40_issuerC, Issuer as imported41_Issuer, Issuer as imported38_Issuer, IssuerC as imported42_IssuerC, Issuer as imported40_Issuer, Issuer as imported42_Issuer, issuerC as imported38_issuerC, IssuerC as imported37_IssuerC, IssuerC as imported39_IssuerC, issuerC as imported37_issuerC, Issuer as imported39_Issuer, IssuerC as imported38_IssuerC } from "./issuer";
import { Ord as stringOrd } from "fp-ts/lib/string";
import { IssuerOrProgramRatingCU as imported7_IssuerOrProgramRatingCU, IssuerOrProgramRatingU as imported3_IssuerOrProgramRatingU, IssuerOrProgramRatingCU as imported6_IssuerOrProgramRatingCU } from "./ratingBase";
import { BidSubmissionTemplateDataC as imported7_BidSubmissionTemplateDataC, BidSubmissionTemplateData as imported7_BidSubmissionTemplateData, bidSubmissionTemplateDataC as imported7_bidSubmissionTemplateDataC } from "./bidSubmissionTemplates";
import { IssuerNewsC as imported14_IssuerNewsC, IssuerNews as imported14_IssuerNews, issuerNewsC as imported14_issuerNewsC } from "./issuerNewsBase";
import { DocumentWithCategoryC as imported12_DocumentWithCategoryC, DocumentWithCategory as imported12_DocumentWithCategory, documentWithCategoryC as imported12_documentWithCategoryC } from "./document";
import { MediaC as imported50_MediaC, Media as imported50_Media, mediaC as imported48_mediaC } from "./media";
import { LocalDateTimeFromIsoStringC, LocalDateC } from "../../codecs/localDate";
import { SubscribedC as imported21_SubscribedC, subscribedC as imported21_subscribedC, Subscribed as imported22_Subscribed, SubscribedC as imported22_SubscribedC, subscribedC as imported22_subscribedC, Subscribed as imported21_Subscribed } from "./subscribed";
import { LocalDateTime, LocalDate } from "@js-joda/core";
import { BondOfferingC as imported21_BondOfferingC, BondOffering as imported21_BondOffering, bondOfferingC as imported21_bondOfferingC } from "./bondOfferingBase";
import { RfpC as imported38_RfpC, Rfp as imported38_Rfp, rfpC as imported36_rfpC } from "./rfpBase";
import { OptionFromNullableC, optionFromNullable } from "io-ts-types/lib/optionFromNullable";
import { BidSubmissionDataC as imported8_BidSubmissionDataC, BidSubmissionData as imported8_BidSubmissionData, bidSubmissionDataC as imported8_bidSubmissionDataC } from "./bidSubmissions";
import * as RNEA from "fp-ts/lib/ReadonlyNonEmptyArray";
import { RoadShowData as imported17_RoadShowData, RoadShowData as imported18_RoadShowData, roadShowDataC as imported18_roadShowDataC, RoadShowDataC as imported17_RoadShowDataC, RoadShowDataC as imported18_RoadShowDataC, roadShowDataC as imported17_roadShowDataC } from "./roadshow";

export const create = {
  _tag: `Create`,
  name: `Create`
} as const;

export type CreateTaggedC = t.TypeC<{
  _tag: t.LiteralC<`Create`>
}>;
export const createTaggedC: CreateTaggedC = t.type({
  _tag: t.literal(`Create`)
});
export type CreateTagged = t.TypeOf<CreateTaggedC>;
export type Create = CreateTagged & typeof create;
export type CreateC = t.Type<Create, CreateTagged>;
export const createC: CreateC = pipe(createTaggedC, c => new t.Type<Create, CreateTagged>(
  `Create`,
  (u: unknown): u is Create => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, Create> => pipe(c.decode(u), E.map(x => ({ ...x, ...create }))),
  (x: Create): CreateTagged => ({ ...x, _tag: `Create`}),
)) satisfies t.Type<Create, unknown>;


export const update = {
  _tag: `Update`,
  name: `Update`
} as const;

export type UpdateTaggedC = t.TypeC<{
  _tag: t.LiteralC<`Update`>
}>;
export const updateTaggedC: UpdateTaggedC = t.type({
  _tag: t.literal(`Update`)
});
export type UpdateTagged = t.TypeOf<UpdateTaggedC>;
export type Update = UpdateTagged & typeof update;
export type UpdateC = t.Type<Update, UpdateTagged>;
export const updateC: UpdateC = pipe(updateTaggedC, c => new t.Type<Update, UpdateTagged>(
  `Update`,
  (u: unknown): u is Update => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, Update> => pipe(c.decode(u), E.map(x => ({ ...x, ...update }))),
  (x: Update): UpdateTagged => ({ ...x, _tag: `Update`}),
)) satisfies t.Type<Update, unknown>;


export const allActivityActionC = [createC, updateC] as const;
export const allActivityActionNames = [`Create`, `Update`] as const;
export type ActivityActionName = (typeof allActivityActionNames)[number];

export type ActivityActionCU = t.UnionC<[CreateC, UpdateC]>;
export type ActivityActionU = Create | Update;
export const ActivityActionCU: ActivityActionCU = t.union([createC, updateC]) satisfies t.Type<ActivityActionU, unknown>;

export const activityActionOrd: Ord.Ord<ActivityActionU> = pipe(stringOrd, Ord.contramap(x => x._tag));
export const allActivityAction = [create, update] as const;
export type ActivityActionMap<A> = { [K in ActivityActionName]: A };


export type OfferingItemC = t.TypeC<{
  _tag: t.LiteralC<`OfferingItem`>,
  item: imported21_SubscribedC<imported447_WithStatusCU<imported130_WithModInfoC<imported118_TaggedContentC<imported21_BondOfferingC>>>>,
  roadshows: t.ReadonlyArrayC<imported153_WithIdC<imported119_TaggedContentC<imported17_RoadShowDataC>>>,
  documents: t.ReadonlyArrayC<imported154_WithIdC<imported120_TaggedContentC<imported50_MediaC>>>,
  issuer: imported37_IssuerC,
  at: LocalDateTimeFromIsoStringC,
  action: ActivityActionCU
}>;
export type OfferingItem = {
  _tag: `OfferingItem`,
  item: imported21_Subscribed<imported223_WithStatusU<imported130_WithModInfo<imported118_TaggedContent<imported21_BondOffering>>>>,
  roadshows: ReadonlyArray<imported153_WithId<imported119_TaggedContent<imported17_RoadShowData>>>,
  documents: ReadonlyArray<imported154_WithId<imported120_TaggedContent<imported50_Media>>>,
  issuer: imported37_Issuer,
  at: LocalDateTime,
  action: ActivityActionU
};
export const offeringItemC: OfferingItemC = t.type({
  _tag: t.literal(`OfferingItem`),
  item: imported21_subscribedC(imported446_WithStatusCU(imported130_withModInfoC(imported118_taggedContentC(imported21_bondOfferingC)))),
  roadshows: t.readonlyArray(imported153_withIdC(imported119_taggedContentC(imported17_roadShowDataC))),
  documents: t.readonlyArray(imported154_withIdC(imported120_taggedContentC(imported48_mediaC))),
  issuer: imported36_issuerC,
  at: LocalDateTimeFromIsoStringC,
  action: ActivityActionCU
}) satisfies t.Type<OfferingItem, unknown>;


export type NewsItemC = t.TypeC<{
  _tag: t.LiteralC<`NewsItem`>,
  item: imported155_WithIdC<imported131_WithModInfoC<imported121_TaggedContentC<imported14_IssuerNewsC>>>,
  issuer: imported38_IssuerC,
  at: LocalDateTimeFromIsoStringC
}>;
export type NewsItem = {
  _tag: `NewsItem`,
  item: imported155_WithId<imported131_WithModInfo<imported121_TaggedContent<imported14_IssuerNews>>>,
  issuer: imported38_Issuer,
  at: LocalDateTime
};
export const newsItemC: NewsItemC = t.type({
  _tag: t.literal(`NewsItem`),
  item: imported155_withIdC(imported131_withModInfoC(imported121_taggedContentC(imported14_issuerNewsC))),
  issuer: imported37_issuerC,
  at: LocalDateTimeFromIsoStringC
}) satisfies t.Type<NewsItem, unknown>;


export type CalendarItemC = t.TypeC<{
  _tag: t.LiteralC<`CalendarItem`>,
  item: imported156_WithIdC<imported132_WithModInfoC<imported12_EventC>>,
  issuer: imported39_IssuerC,
  at: LocalDateTimeFromIsoStringC
}>;
export type CalendarItem = {
  _tag: `CalendarItem`,
  item: imported156_WithId<imported132_WithModInfo<imported12_Event>>,
  issuer: imported39_Issuer,
  at: LocalDateTime
};
export const calendarItemC: CalendarItemC = t.type({
  _tag: t.literal(`CalendarItem`),
  item: imported156_withIdC(imported132_withModInfoC(imported11_eventC)),
  issuer: imported38_issuerC,
  at: LocalDateTimeFromIsoStringC
}) satisfies t.Type<CalendarItem, unknown>;


export type DocumentUploadC = t.TypeC<{
  _tag: t.LiteralC<`DocumentUpload`>,
  item: imported157_WithIdC<imported133_WithModInfoC<imported122_TaggedContentC<imported12_DocumentWithCategoryC>>>,
  issuer: imported40_IssuerC,
  at: LocalDateTimeFromIsoStringC
}>;
export type DocumentUpload = {
  _tag: `DocumentUpload`,
  item: imported157_WithId<imported133_WithModInfo<imported122_TaggedContent<imported12_DocumentWithCategory>>>,
  issuer: imported40_Issuer,
  at: LocalDateTime
};
export const documentUploadC: DocumentUploadC = t.type({
  _tag: t.literal(`DocumentUpload`),
  item: imported157_withIdC(imported133_withModInfoC(imported122_taggedContentC(imported12_documentWithCategoryC))),
  issuer: imported39_issuerC,
  at: LocalDateTimeFromIsoStringC
}) satisfies t.Type<DocumentUpload, unknown>;


export type BondRatingItemC = t.TypeC<{
  _tag: t.LiteralC<`BondRatingItem`>,
  item: imported158_WithIdC<imported134_WithModInfoC<imported7_IssuerOrProgramRatingCU>>,
  issuer: imported41_IssuerC,
  at: LocalDateTimeFromIsoStringC,
  action: ActivityActionCU
}>;
export type BondRatingItem = {
  _tag: `BondRatingItem`,
  item: imported158_WithId<imported134_WithModInfo<imported3_IssuerOrProgramRatingU>>,
  issuer: imported41_Issuer,
  at: LocalDateTime,
  action: ActivityActionU
};
export const bondRatingItemC: BondRatingItemC = t.type({
  _tag: t.literal(`BondRatingItem`),
  item: imported158_withIdC(imported134_withModInfoC(imported6_IssuerOrProgramRatingCU)),
  issuer: imported40_issuerC,
  at: LocalDateTimeFromIsoStringC,
  action: ActivityActionCU
}) satisfies t.Type<BondRatingItem, unknown>;


export type RFPItemC = t.TypeC<{
  _tag: t.LiteralC<`RFPItem`>,
  item: imported22_SubscribedC<imported451_WithStatusCU<imported135_WithModInfoC<imported123_TaggedContentC<imported38_RfpC>>>>,
  roadshows: t.ReadonlyArrayC<imported159_WithIdC<imported124_TaggedContentC<imported18_RoadShowDataC>>>,
  bidSubmissionTemplate: OptionFromNullableC<imported452_WithStatusCU<imported136_WithModInfoC<imported7_BidSubmissionTemplateDataC>>>,
  bidSubmission: OptionFromNullableC<imported453_WithStatusCU<imported137_WithModInfoC<imported8_BidSubmissionDataC>>>,
  issuer: imported42_IssuerC,
  at: LocalDateTimeFromIsoStringC,
  action: ActivityActionCU
}>;
export type RFPItem = {
  _tag: `RFPItem`,
  item: imported22_Subscribed<imported224_WithStatusU<imported135_WithModInfo<imported123_TaggedContent<imported38_Rfp>>>>,
  roadshows: ReadonlyArray<imported159_WithId<imported124_TaggedContent<imported18_RoadShowData>>>,
  bidSubmissionTemplate: O.Option<imported225_WithStatusU<imported136_WithModInfo<imported7_BidSubmissionTemplateData>>>,
  bidSubmission: O.Option<imported226_WithStatusU<imported137_WithModInfo<imported8_BidSubmissionData>>>,
  issuer: imported42_Issuer,
  at: LocalDateTime,
  action: ActivityActionU
};
export const rFPItemC: RFPItemC = t.type({
  _tag: t.literal(`RFPItem`),
  item: imported22_subscribedC(imported448_WithStatusCU(imported135_withModInfoC(imported123_taggedContentC(imported36_rfpC)))),
  roadshows: t.readonlyArray(imported159_withIdC(imported124_taggedContentC(imported18_roadShowDataC))),
  bidSubmissionTemplate: optionFromNullable(imported449_WithStatusCU(imported136_withModInfoC(imported7_bidSubmissionTemplateDataC))),
  bidSubmission: optionFromNullable(imported450_WithStatusCU(imported137_withModInfoC(imported8_bidSubmissionDataC))),
  issuer: imported41_issuerC,
  at: LocalDateTimeFromIsoStringC,
  action: ActivityActionCU
}) satisfies t.Type<RFPItem, unknown>;


export const allIssuerActivityTypeC = [offeringItemC, newsItemC, calendarItemC, documentUploadC, bondRatingItemC, rFPItemC] as const;
export const allIssuerActivityTypeNames = [`OfferingItem`, `NewsItem`, `CalendarItem`, `DocumentUpload`, `BondRatingItem`, `RFPItem`] as const;
export type IssuerActivityTypeName = (typeof allIssuerActivityTypeNames)[number];

export type IssuerActivityTypeCU = t.UnionC<[OfferingItemC, NewsItemC, CalendarItemC, DocumentUploadC, BondRatingItemC, RFPItemC]>;
export type IssuerActivityTypeU = OfferingItem | NewsItem | CalendarItem | DocumentUpload | BondRatingItem | RFPItem;
export const IssuerActivityTypeCU: IssuerActivityTypeCU = t.union([offeringItemC, newsItemC, calendarItemC, documentUploadC, bondRatingItemC, rFPItemC]) satisfies t.Type<IssuerActivityTypeU, unknown>;

export type IssuerActivityTypeMap<A> = { [K in IssuerActivityTypeName]: A };


export type IssuerActivityC = ReadonlyMapFromEntriesC<LocalDateC, ReadonlyNonEmptyArrayType<IssuerActivityTypeCU>>;
export type IssuerActivity = ReadonlyMap<LocalDate, RNEA.ReadonlyNonEmptyArray<IssuerActivityTypeU>>;
export const issuerActivityC: IssuerActivityC = readonlyMapFromEntries(LocalDateC, LocalDateOrd, readonlyNonEmptyArrayC(IssuerActivityTypeCU)) satisfies t.Type<IssuerActivity, unknown>;


